import { BaseLogin } from './Login';
import { BaseDocumentDisplay } from './DocumentDisplay';
import { BaseFaceRecognition } from './FaceRecognition';
import { BasePersonalDocument } from './PersonalDocument';
import { BaseOTP } from './OTP';
import { BaseSignedPage } from './SignedPage';
import { BaseCanceledPage } from './CanceledPage';
import { BaseLoading } from './Loading';
import { BaseDeviceScan } from './DeviceScan';

export const BaseTheme = {
    Loading: BaseLoading,
    Login: BaseLogin,
    DocumentDisplay: BaseDocumentDisplay,
    DeviceScan: BaseDeviceScan,
    FaceRecognition: BaseFaceRecognition,
    PersonalDocument: BasePersonalDocument,
    OTP: BaseOTP,
    SignedPage: BaseSignedPage,
    CanceledPage: BaseCanceledPage,
} as const;
